module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-in-header"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.linkToHome),
      expression: "linkToHome"
    }],
    staticClass: "logo",
    attrs: {
      "to": "/",
      "aria-label": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/home/header_logo.png",
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ce11972a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logoInHeader/LogoInHeader.vue
// module id = 1391
// module chunks = 1